import "@/App.css";
import { useState } from "react";
import LandingPage from "./components/LandingPage";
import AdminPage from "./components/AdminPage";

function App() {
  const [view, setView] = useState("landing"); // "landing" | "admin"

  return (
    <div>
      {view === "admin" ? (
        <AdminPage onBack={() => setView("landing")} />
      ) : (
        <LandingPage onAdminClick={() => setView("admin")} />
      )}
    </div>
  );
}

export default App;
